import { validateSomething } from "../../Form/Validations";
import { toast } from "react-toastify";
import RestAPI from "@aws-amplify/api-rest";
import { utcToDate } from "../../../utils/date";

export class Irrimax {
    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, i18n) {
        const now = new Date();
        const minDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 3,
            new Date().getDate()
        );
        const timezones = Intl.supportedValuesOf("timeZone").map(t => ({ label: t, value: t }));
        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const selected = props.dialogState.data.supportedLoggers.find(l => l.id === values.loggerId);
                const body = {
                    tipo: "IRRIMAX",
                    loggerName: selected?.name,
                    sectorName: values.sectorName,
                    nodeName: values.sectorName,
                    from: utcToDate(values.from.toISOString(), props.timezone, true).format(),
                    timezone: values.advancedOptions ? (values.timezone ?? null) : null,
                    apiKey: props.dialogState.data.apiKey,
                    locale: i18n.language
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("external.login"),
                    validateFunction: this.validateLogin,
                    inputs: [
                        {
                            label: "API Key",
                            campo: "apiKey",
                            validation: validateSomething,
                            component: "text",
                        },
                    ],
                },
                {
                    label: t("external.conectar"),
                    inputs: [
                        {
                            component: "info",
                            content: (dialogState) => {
                                return (<>
                                    {dialogState?.data.unsupportedLoggers?.length > 0 && (
                                        <>
                                            <div className="col-12 col-md-12">
                                                <label className="boldie text-left">
                                                    Unsupported Loggers
                                                </label>
                                            </div>
                                            <div className="mb-2 col-12 col-md-12 d-block">
                                                <ul>
                                                    {dialogState.data.unsupportedLoggers.map((logger, id) => {
                                                        return <li key={id}> {logger} </li>;
                                                    })}
                                                </ul>
                                            </div>
                                        </>
                                    )}
                                </>);
                            }
                        },
                        {
                            label: "Logger",
                            campo: "loggerId",
                            validation: validateSomething,
                            component: "select",
                            optionsName: "supportedLoggers",
                            optionLabel: "name",
                            optionKey: "id",
                            onChange: (value, props, options) => {
                                const sectorName = options.find(o => o.id === value)?.name ?? "";
                                props.setFieldValue("sectorName", sectorName);
                            }
                        },
                        {
                            label: t("external.sector-name"),
                            campo: "sectorName",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            label: t("node.ultimoDato"),
                            campo: "from",
                            validation: validateSomething,
                            component: "date",
                            minDate,
                            maxDate: now
                        },
                        {
                            label: t("external.advancedOptions"),
                            campo: "advancedOptions",
                            component: "checkbox",
                        },
                        {
                            label: t("external.timezoneOfData"),
                            campo: "timezone",
                            validation: validateSomething,
                            component: "select",
                            options: timezones,
                            triggeredBy: "advancedOptions"
                        },
                        {
                            component: "info",
                            triggeredBy: "loggerId",
                            optionsKey: "id",
                            optionsName: "supportedLoggers",
                            content: (_,selected) => {
                                return (<>
                                    <div className="col-12 col-md-12">
                                        <label className="boldie text-left">
                                            {t("external.availableSensors")}
                                        </label>
                                    </div>
                                    <div className="mb-2 col-12 col-md-12 d-block">
                                        <ul>
                                            {!selected.sensors.length && (
                                                <li>No sensors</li>
                                            )}
                                            {selected.sensors.map((sensor, id) => {
                                                let text = sensor.tipo;
                                                if (sensor.depths?.length > 0) {
                                                    const depthsText = sensor.depths.join(", ");
                                                    text += ` (${depthsText})`;
                                                }
                                                return <li key={id}> {text} </li>;
                                            })}
                                        </ul>
                                    </div>
                                </>);
                            }
                        },
                    ],
                },
            ],
        };
    }

    static async validateLogin(values, props) {
        const isSubmitting = props.innerRef.current.isSubmitting;
        const errors = {};
        try {
            if (values) {
                const errApiKey = validateSomething(values.apiKey);
                if (errApiKey !== undefined) errors.apiKey = errApiKey;

                if(errors.apiKey) return errors;

                if (isSubmitting){
                    props.setForceLoading(true);

                    const endpoint = `/external/${props.farmId}/irrimax-credentials`;
                    const body = { apiKey: values.apiKey, locale: props.i18n.language };
                    const irrimaxData = await RestAPI.post("apiAdminDropControl", endpoint, { body });

                    // set data that it will be used in the next step of the form
                    props.setDialogState(s => ({
                        ...s,
                        data: {
                            apiKey: values.apiKey,
                            supportedLoggers: irrimaxData.supportedLoggers,
                            unsupportedLoggers: irrimaxData.unsupportedLoggers,
                        }
                    }));

                    props.setForceLoading(false);
                }
                return errors;
            }
        } catch (error) {
            toast.error(props.t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
            errors.unknown = props.t("external.error-sign-in");
            props.setForceLoading(false);
            return errors;
        }
    }
}
